import { FETCH_ARTIST_SUCCESS, FETCH_ARTIST_FAILED, CLEAR_ARTIST } from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  results: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ARTIST_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
        results: action.results,
      };
    case FETCH_ARTIST_FAILED:
      return { ...state, status: 'error', error: action.error };
    case CLEAR_ARTIST:
      return { ...initialState, status: 'clear' };
    default:
      return state;
  }
};
